const PD_WEB_SERVER = process.env.PD_WEB_SERVER || process.env.REACT_APP_PD_WEB_SERVER || '';
const HTTP = 'http';
const HTTPS = 'https://';
const WS   = 'ws';
const WSS  = 'wss://';

export const protocols = {
  HTTP,
  HTTPS,
  WS,
  WSS
}

export const env = {
  PD_WEB_SERVER,
}